<template>
    <div style="pointer-events: all" class="widget-html"></div>
</template>

<script>
export default {
    props: {
        settings: {
            type: Object,
            default: () => {}
        }
    },
    name: "WidgetHtmlBlock",
    mounted() {
        const div = document.createElement("div")
        div.innerHTML = this.settings.general.html
        div.querySelectorAll("script").forEach(s => {
            const script = document.createElement("script")
            script.src = s.src
            script.dataset.loaded = true
            script.innerHTML = s.innerHTML
            document.body.appendChild(script)
        })
        this.$el.innerHTML = div.innerHTML
    }
}
</script>

<style lang="sass" scoped>

</style>
